const progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);

export { progress };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/progress.es.js
// module id = ALji
// module chunks = 0